import { createBomPartlistApi } from "@org-avp/avp-avengers-bompartlist-service-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { FetchBaseQueryArgs } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const defaultPageSize = 5_000;
const defaultMaxEntriesToLoad = 50_000;
const baseQueryArgs: FetchBaseQueryArgs = {
  baseUrl: environment.NX_PROJECT_SERVICE_BASE_URL,
  prepareHeaders,
};

export const bomPartlistApi = createBomPartlistApi({
  maxEntriesToLoad: defaultMaxEntriesToLoad,
  pageSize: defaultPageSize,
  baseQueryArgs,
});
